import React from 'react';
import FullWidthContainer from '../../components/Layout/FullWidthContainer';
import {Container} from "@mui/material";

export default function Footer() {
    return (
            <div>Gloria, Isabella, Verena & Manuel</div>
    )
}
